import { executeCapability } from '../utils/capabilityExecute'

export interface NotificationSettingsData {
  key: string
  clockOutAfterHours: number
  dailyFormsAfterHours: number
  dailyFormsFolders: string[]
  reminderResendAfterHours: number
  reminderMaxSends: number
  updatedAt: string | null
}

export interface NotificationSettingsUpdate {
  clockOutAfterHours?: number
  dailyFormsAfterHours?: number
  dailyFormsFolders?: string[]
  reminderResendAfterHours?: number
  reminderMaxSends?: number
}

export const notificationSettingsService = {
  async get(): Promise<NotificationSettingsData> {
    return executeCapability<NotificationSettingsData>({
      app: 'admin',
      capability: 'notifications.settings.get',
      input: {},
    })
  },

  async update(input: NotificationSettingsUpdate): Promise<NotificationSettingsData> {
    return executeCapability<NotificationSettingsData>({
      app: 'admin',
      capability: 'notifications.settings.update',
      input,
    })
  },
}
